import indexMixin from "../mixins/index";
export default {
  name: "res-slider",
  mixins: [indexMixin],

  data() {
    return {
      dataModel: this.value // 竖直方向时，step太小且高度太小时会出现竖条不见了的情况
      // input只能在非range的情况下才能出来
      // 竖直情况下最好不要开启input，效果不好

    };
  },

  props: {
    marks: {
      type: Object,
      default: () => {}
    },
    value: {
      type: [Number, Array]
    },
    range: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    valueToLabel() {
      // 优先取marks中的内容
      if (this.range) {
        // 范围选择时
        return this.marks[this.dataModel[0]] || this.dataModel[0] + "-" + this.marks[this.dataModel[1]] || this.dataModel[1];
      } // 非范围选择


      return this.marks[this.dataModel] || this.dataModel;
    }

  },
  watch: {
    dataModel(val) {
      this.$emit("input", val);
    },

    value(val) {
      this.dataModel = val;
    }

  }
};